var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIosStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M11.795 4.542h-3.94L6.656.969A.423.423 0 0 0 6.25.685a.423.423 0 0 0-.407.284L4.646 4.542H.679a.43.43 0 0 0-.42.5c.004.094.047.199.179.303l3.238 2.282-1.243 3.614a.43.43 0 0 0 .147.482c.078.056.15.104.241.104a.525.525 0 0 0 .268-.096L6.25 9.478l3.16 2.253c.076.054.18.096.269.096.09 0 .163-.045.238-.104a.425.425 0 0 0 .147-.482L8.821 7.627l3.212-2.303.078-.067c.07-.075.139-.177.139-.287 0-.235-.22-.428-.455-.428z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosStar);
export default __webpack_public_path__ + "static/media/ios-star.d263c85308671ce7201eed9fe1a99902.svg";
export { ForwardRef as ReactComponent };